import { useEffect } from "react";
import Lenis from "lenis";
import { motion } from "framer-motion";
import React from "react";

export function useLenis() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    let raf;
    const loop = (time) => { lenis.raf(time); raf = requestAnimationFrame(loop); };
    raf = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(raf); lenis.destroy(); };
  }, []);
}

// Masked line-by-line reveal
export const MaskLine = ({ children, delay = 0, className = "" }) => (
  <span className="reveal-mask block">
    <motion.span
      className={"block " + className}
      initial={{ y: "110%" }}
      animate={{ y: "0%" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.span>
  </span>
);

export const Reveal = ({ children, delay = 0, y = 40, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.7, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const fmtDate = (iso, lang = "nl") => {
  try {
    return new Date(iso).toLocaleDateString(lang === "nl" ? "nl-BE" : lang === "fr" ? "fr-BE" : "en-GB",
      { day: "numeric", month: "short" });
  } catch { return iso; }
};
export const fmtTime = (iso) => {
  try { return new Date(iso).toLocaleTimeString("nl-BE", { hour: "2-digit", minute: "2-digit" }); }
  catch { return ""; }
};
export const fmtDay = (iso, lang = "nl") => {
  try { return new Date(iso).toLocaleDateString(lang === "nl" ? "nl-BE" : lang === "fr" ? "fr-BE" : "en-GB", { weekday: "long" }); }
  catch { return ""; }
};
